import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_RULE_API } from "./apiRoutes";
interface UseGetRuleByIdProps {
  ruleId: string;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getRuleById = async (ruleId: string, communityId: string) =>
  await axiosAuth.get(`${DISTRIBUTION_RULE_API(communityId)}/${ruleId}`);

const useGetRuleById = ({
  queryParams,
  ruleId,
  communityId
}: UseGetRuleByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["distribution-rule-by-id", ruleId],
    queryFn: () => getRuleById(ruleId, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && !!ruleId && (queryParams?.enabled ?? true),
  });
};

export default useGetRuleById;
